var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GlobalWindow',{attrs:{"size":"600px","title":_vm.title,"visible":_vm.visible,"with-footer":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('pre',[_vm._v(_vm._s(this.AiAnswer))])])
}
var staticRenderFns = []

export { render, staticRenderFns }